import { render, staticRenderFns } from "./PortablesEnrollmentModals.vue?vue&type=template&id=2a822748&scoped=true"
import script from "./PortablesEnrollmentModals.vue?vue&type=script&lang=js"
export * from "./PortablesEnrollmentModals.vue?vue&type=script&lang=js"
import style0 from "./PortablesEnrollmentModals.vue?vue&type=style&index=0&id=2a822748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a822748",
  null
  
)

export default component.exports